import { usePost } from '../../../../api';
import { useCallback } from 'react';

export type GenerateReportResponse = {
    shadowAdminsReportGenerated: boolean;
    shadowAdminsReportFileName: string;
    shadowAdminsReportDate: string;
};

export const useGenerateShadowAdminsReport = () => {
    const { post, loading, error } = usePost<void, GenerateReportResponse>({
    });

    const generateReport = useCallback(async (): Promise<GenerateReportResponse | undefined> => {
        try {
            const response = await post('/insights/generateShadowAdminsReport', undefined);
            return response?.data;
        } catch (err) {
            console.error('Failed to generate report:', err);
            return undefined;
        }
    }, [post]);

    return {
        generateReport,
        loading,
        error
    };
};